import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"
import { Login } from "./Login"
import { useParams } from "react-router-dom"

export const LoginWithCaptcha = () => {
    const { adminUser } = useParams()

    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ""}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: "head",
            }}
        >
            <Login key={adminUser} />
        </GoogleReCaptchaProvider>
    )
}